<template>
    <transition :name="transitionName">
        <keep-alive :include="onlyCache" :exclude="doNotCache">
            <router-view :eventBus="eventBus" @toggle-side-bar="toggleSideBar"></router-view>
        </keep-alive>
    </transition>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
    name: 'vx-app-module-root',
    props: {
        doNotCache: {
            type: Array,
            default: () => []
        },
        onlyCache: {
            type: Array,
            default: () => []
        },
        requiredModules: {
            type: [Array, Object],
            default: () => []
        }
    },
    computed: {
        ...mapGetters({
            breadcrumb: 'router/breadcrumb',
            isNavigatingBack: 'router/isNavigatingBack'
        }),
        transitionName() {
            if (this.isNavigatingBack) {
                return 'slide-swap-back'
            }
            return 'slide-swap'
        },
        requiredModules_x() {
            if (Array.isArray(this.requiredModules)) {
                return this.requiredModules
            }
            return [this.requiredModules]
        }
    },
    watch: {
        // requiredModules_x: {
        //     handler: function (newV, oldV) {
        //         if (!oldV) {
        //             oldV = []
        //         }
        //         if (!newV) {
        //             newV = []
        //         }
        //         var newModules = newV.where((mod) => !oldV.contains(mod))
        //         var removedModules = oldV.where((mod) => !newV.contains(mod))
        //         console.log('Adding Modules: ', newModules)
        //         console.log('Removing Modules: ', removedModules)
        //         // this.unregister(removedModules)
        //         this.register(newModules)
        //     },
        //     immediate: true
        // }
    },
    data() {
        return {
            eventBus: new Vue()
        }
    },
    methods: {
        register(modules) {
            if (!modules || !modules.any()) {
                return
            }
            modules.forEach(this.$store.register)
        },
        unregister(modules) {
            if (!modules || !modules.any()) {
                return
            }
            modules.forEach(this.$store.unregister)
        }
    },
    created() {
        this.register(this.requiredModules_x)
    },
    destroy() {
        this.eventBus.$off()
    }
}
</script>
